import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { PLATFORM, platformLogin } from "@/lib/platform";

export default function ProtectedRoute({ children }) {
  const { user, platformError } = useAuth();
  if (!user && PLATFORM && !platformError) {
    platformLogin(); // the platform's sign-in, back to this page afterwards
    return null;
  }
  if (!user) return <Navigate to="/admin/login" replace />;
  return children;
}
